import React, { useCallback } from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import AccordionIcon from '../../../../../components/Accordion/AccordionIcon'
import AccordionLabel from '../../../../../components/Accordion/AccordionLabel'
import { useCompensationPopupStyles } from '../styles'
import PayoutLabel, { PayoutLabelProps } from './PayoutLabel'

type ClassNames = { label?: PayoutLabelProps['classes']; container?: string }

export type UseAccordionLabelProps = {
  value: PayoutLabelProps['value']
  label: PayoutLabelProps['label']
  format?: PayoutLabelProps['format']
  classNames?: (isOpened: boolean) => ClassNames
  icon?: (isOpened: boolean) => React.ReactNode
}

const useAccordionLabel = ({ value, label, format = 'euroInt', classNames, icon }: UseAccordionLabelProps) => {
  const classes = useCompensationPopupStyles()
  const { t } = useTranslation()

  return useCallback(
    (isOpened: boolean) => (
      <AccordionLabel
        className={clsx(classes.accordionLabel, classNames?.(isOpened)?.container)}
        icon={icon ? icon(isOpened) : <AccordionIcon isOpened={isOpened} />}
      >
        <PayoutLabel
          classes={classNames?.(isOpened)?.label}
          label={t(`compensation_popup_${label}_label`)}
          value={value}
          format={format}
        />
      </AccordionLabel>
    ),

    [value, format, label, t, classes, classNames, icon]
  )
}

export default useAccordionLabel
